import * as Yup from "yup";

export const initialValues = {
  password: "",
  confirmPassword: "",
};

export const validationSchema = Yup.object({
  password: Yup.string()
    .required("Password must have at least one non space character")
    .matches(/.*\S.*/, "Password must have at least one non space character")
    .min(6, "Must be more than 6 characters")
    .max(72, "Password cannot be more than 72 characters"),
  confirmPassword: Yup.string()
    .required("Passwords must match")
    .test("passwords-match", "Passwords must match", function(value) { // eslint-disable-line
      return this.parent.password === value;
    }),
});
